import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

function ProtectedLayout() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-6">
        {/* 👇 Nyckeln gör att barnen mountas om vid navigation */}
        <div key={location.pathname}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default ProtectedLayout;
